import React from "react";
import "./WorkHistory.css";

// You can easily update your work history here
const workData = [
  {
    role: "Software Engineer & Analyst",
    company: "Moly Manufacturing/Kansas Rural Communications",
    duration: "Apr 2025 - Present",
    responsibilities: [
      "Built React.js Drag & Drop designer web app with API to enable layout saving and user authentication.",
      "Built an internal .NET Windows program to transcribe customer service calls and genereate wiki documentation using Whisper & Groq LLMs.",
      "Developed and documented GIS analysis and reporting to comply with FCC requirements for ISPs.",
      "Managed ISP Network & Subscriber billing system (UISP) utilizing the APIs for advanced reporting.",
      "Developed custom code solutions for a B2B web shop to enable custom product configurations and orders.",
      "Implemented and maintained company Wiki for extensive development workflows and business operations.",
    ],
  },
  {
    role: "Software Engineer",
    company: "Seed Research Equipment Solutions (SRES) & Kincaid Manufacturing",
    duration: "Oct 2020 - Aug 2024",
    responsibilities: [
      "Developed and maintained C# .NET Windows software for GPS-guided farm implements, contributing to precision agriculture solutions. ",
      "Designed and implemented microcontroller firmware using Arduino C++ and MicroPython, integrating wireless communication and sensor data processing for robotics control.",
      "Tempus leo eu aenean sed diam urna tempor.",
      "Created and maintained comprehensive technical documentation (Azure DevOps wikis) detailing design and programming decisions, ensuring project clarity and maintainability.",
    ],
  },
  {
    role: "Developer",
    company: "Pipeline Testing Consortium",
    duration: "Feb 2020 - April 2020",
    responsibilities: [
      "Developed and maintained ASP.NET WebForms websites using C#/.NET, addressing bug fixes and implementing new features. ",
      "Designed and implemented a new customer enrollment module, including database schema design and UI development.",
      "Proficiently utilized MSSQL for database management, data manipulation, and reporting.",
    ],
  },
  {
    role: "IT Programmer",
    company: "Striaghtline HDD",
    duration: "May 2019 - August 2019",
    responsibilities: [
      "Developed SQL scripts to analyze, combine, and deduplicate data from multiple SQL databases, improving reporting accuracy and efficiency.",
      "Modernized a PHP REST API, enabling efficient data retrieval for online sales reporting and providing valuable insights for business decisions. ",
      "Automated a manual process by creating a WinForms application for managing shipping records, freeing up supervisor time and improving workflow.",
    ],
  },
  {
    role: "Developer/Analyst",
    company: "AgVantis",
    duration: "Feb 2017 - Aug 2018",
    responsibilities: [
      "Developed and debugged Windows Dynamics CRM software using C#/.NET, contributing to a critical financial application for Farm Credit Unions.",
      "Designed and implemented database structures and SQL queries, ensuring data integrity and efficient data access within the banking software. ",
      "Collaborated effectively within an Agile development environment, participating in sprint planning, story tracking, and issue resolution.",
    ],
  },
  {
    role: "Programmer & Video Editor",
    company: "Solutions, Inc.",
    duration: "March 2007 - Feb 2017",
    responsibilities: [
      "Led the full software development lifecycle for a native Android and iOS marketing app (Java/Cordova).",
      "Designed, developed, and maintained a media-rich company website using HTML5/CSS/Javascript, including a secure login system and Arabic translation.",
      "Produced and edited marketing and educational videos using Final Cut Pro, and created compelling marketing graphics using Adobe Photoshop and Illustrator, demonstrating multimedia skills. ",
    ],
  },
];

function WorkHistory() {
  return (
    <section id="work-history" className="section">
      <div className="container">
        <h2 className="section-title">Work History</h2>
        <div className="timeline">
          {workData.map((job, index) => (
            <div className="timeline-item" key={index}>
              <div className="timeline-content">
                <h3 className="job-role">{job.role}</h3>
                <h4 className="job-company">
                  {job.company} | {job.duration}
                </h4>
                <ul className="job-responsibilities">
                  {job.responsibilities.map((task, i) => (
                    <li key={i}>{task}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WorkHistory;
